<template>
  <!--sanya: added css classes and padding to make this page similar to all other pages-->
  <div class="outer-wrapper" style="text-align: justify">
    <div class="page-header clear-filter"></div>
    <div
      class="ls section fixedTopSpacingOrder fixedContentMobileview"
      id="hideTopSpacingDivOrder"
    >
      <div class="container">
        <div class="row pd-top-10" style="text-align: justify">
          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top: 18px">
            <h5>Refund and Cancellation Policy</h5>
            <p>
              Our focus is complete customer satisfaction. In the event, if you
              are displeased with the services provided, we will refund back the
              money, provided the reasons are genuine and proved after
              investigation. Please read the fine prints of each deal before
              buying it, it provides all the details about the services or the
              product you purchase.
            </p>

            <p>
              In case of dissatisfaction from our services, clients have the
              liberty to cancel their projects and request a refund from us. Our
              Policy for the cancellation and refund will be as follows:
            </p>

            <h5>Cancellation Policy</h5>

            <p>For Cancellations please contact us via contact us link.</p>

            <p>
              Requests received later than 1 business days prior to the end of
              the current service period will be treated as cancellation of
              services for the next service period.
            </p>

            <h5>Return and Refunds</h5>

            <p>
              We will try our best to create the suitable design concepts for
              our clients.
            </p>

            <p>
              In case any client is not completely satisfied with our products
              we can provide a refund.
            </p>

            <p>
              If paid by credit card, refunds will be issued to the original
              credit card provided at the time of purchase and in case of
              payment gateway name payments refund will be made to the same
              account.
            </p>

            <p><b>First Escalation:</b></p>
            <p>Grievance officer: Sudhir</p>
            <p>
              Email: <a href="mailto:care@doodhvale.com">care@doodhvale.com</a>
            </p>
            <p>
              Helpline Phone No: <a href="tel:918010342342">+91-8010 342 342</a>
            </p>
            <p>WhatsApp No: <a href="tel:918851226549">+91-8851 226 549</a></p>
            <p>Turnaround Time: Within 48 hours escalation</p>

            <p><b>Second escalation:</b></p>

            <p>Nodal officer: Ishu Jain</p>
            <p>
              Email: <a href="mailto:ishu@doodhvale.com">ishu@doodhvale.com</a>
            </p>

            <p>Turnaround Time: Within 7 days from escalation</p>

            <h5>Process Flow</h5>

            <p>http://sanjeevanidairyfarms.com/process-flow</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>